module.exports = __webpack_public_path__ + "media/images/badges/akt/challenge/challenge_default-4b5561c1399cb8b5ec8bc912d29ae2de.png";